import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("OutroPageWidget", {
  title: "Outro Page",
  attributes: {
    headline: {
      title: "Headline",
    },
    hint: {
      title: "Message",
      description: "This message will be shown underneath the headline",
    },
  },
  properties: ["headline", "hint"],
  initialContent: {
    headline: "Vielen Dank!",
    hint: "Ihre Anfrage wurde verschickt.",
  },
});
